module.exports = __webpack_public_path__ + "media/img/pages/profile/lgt ger 8-a72da177eb9b71fa410d686777834d37.jpg";